import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../store/slices/authSlice";
import { API_CONFIG } from "../config";

interface TwitterLoginProps {
  onLoginStart?: () => void;
  onLoginSuccess?: () => void;
  onLoginFailure?: (error: string) => void;
  buttonText?: string;
  className?: string;
}

const TwitterLogin: React.FC<TwitterLoginProps> = ({
  onLoginStart,
  onLoginSuccess,
  onLoginFailure,
  buttonText = "Login with Twitter",
  className = "twitter-login-button",
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // Обработка callback от Twitter
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get("access_token");
    const refreshToken = urlParams.get("refresh_token");
    const userId = urlParams.get("user_id");
    const username = urlParams.get("username");
    const error = urlParams.get("auth_error");

    // Если есть токены в URL, значит это callback после успешной авторизации
    if (accessToken && refreshToken && userId && username) {
      // Создаем объект пользователя
      const user = {
        id: parseInt(userId),
        username: username,
        email: `${username}@twitter.user`, // Синтетический email
        user_hash: "", // Будет заполнен на бэкенде
      };

      // Обновляем Redux состояние
      dispatch(
        loginSuccess({
          user,
          access_token: accessToken,
        }),
      );

      // Вызываем callback успешной авторизации
      if (onLoginSuccess) {
        onLoginSuccess();
      }

      // Очищаем URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // Если есть ошибка в URL
    if (error) {
      if (onLoginFailure) {
        onLoginFailure(`Twitter authorization error: ${error}`);
      }

      // Очищаем URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [dispatch, onLoginSuccess, onLoginFailure]);

  const handleTwitterLogin = () => {
    if (loading) return;

    try {
      setLoading(true);
      if (onLoginStart) {
        onLoginStart();
      }

      // Перенаправляем на бэкенд для OAuth 1.0a (v1.1)
      window.location.href = `${API_CONFIG.BASE_URL}/twitter/oauth1/start`;
    } catch (error) {
      setLoading(false);
      if (onLoginFailure) {
        onLoginFailure(
          `Initialization error for Twitter auth: ${error instanceof Error ? error.message : "Unknown error"}`,
        );
      }
    }
  };

  return (
    <button
      className={className}
      onClick={handleTwitterLogin}
      disabled={loading}
    >
      <img src="/assets/svg/twitter.svg" alt="Twitter logo" />
      {loading ? "Loading..." : buttonText}
    </button>
  );
};

export default TwitterLogin;
